export default "__VITE_ASSET__DtTKyK8S__"